import BottomDockObserver from './_bottomDockObserver';
var instance = new BottomDockObserver();
export default instance;